import { DropdownOption } from '../types';

type DropdownLike = { label?: string | null; value?: string | number | null };

function findOptionByValue(options: DropdownOption[], value: unknown): DropdownOption | null {
  return options.find((item) => item.value == value) ?? null;
}

export function getOptionValueByLabel(
  options: DropdownLike[] | undefined,
  label: string,
  fallbackValue: unknown,
) {
  return (
    options?.find(
      (item) =>
        String(item?.label ?? '')
          .trim()
          .toLowerCase() === label,
    )?.value ?? fallbackValue
  );
}

/**
 * Returns the latest option object for a selected value.
 *
 * This is required for language switches (for example EN -> DE) so a selected
 * option like "Full FAI" updates to "Vollstaendige FAI" without changing value. - Example
 */
export function syncSelectedOption(
  options: DropdownOption[],
  selectedOption: DropdownOption | null,
): DropdownOption | null {
  const currentValue = selectedOption?.value;
  if (currentValue === null || currentValue === undefined) {
    return null;
  }

  return findOptionByValue(options, currentValue);
}
